import {
  ADD_TO_CART,
  DECREMENT_QUANTITY,
  INCREMENT_QUANTITY,
  REMOVE_FROM_CART,
} from "../actions/type";
import { minValueOne } from "../../utils";

// 🧾 Cart Item Interface
export interface CartItem {
  id: number | string;
  title: string;
  price: number;
  discount?: number;
  qty: number;
  selected_color?: string;
  selected_size?: string;
  sum?: number;
  [key: string]: any; // allows additional optional fields like proImg, etc.
}

// 🧾 Cart State
export interface CartState {
  cart: CartItem[];
}

// 🧾 Action Interface
export interface CartAction {
  type: string;
  product?: CartItem;
  product_id?: number | string;
  qty?: number;
  color?: string;
  size?: string;
}

// 🧾 Initial State
const initialState: CartState = {
  cart: [],
};

// 🧠 Reducer
const cartReducer = (
  state: CartState = initialState,
  action: CartAction
): CartState => {
  switch (action.type) {
    case ADD_TO_CART: {
      const product = action.product;
      const productId = product?.id;
      const productQty = action.qty ?? 1;

      if (!product || !productId) return state;

      const existingProduct = state.cart.find((item) => item.id === productId);

      if (existingProduct) {
        const updatedCart = state.cart.map((item) =>
          item.id === productId
            ? {
                ...item,
                selected_color: action.color,
                selected_size: action.size,
                qty: item.qty + productQty,
                sum:
                  ((item.price * (item.discount ?? 100)) / 100) *
                  (item.qty + productQty),
              }
            : item
        );
        return { ...state, cart: updatedCart };
      }

      // Add new product
      return {
        ...state,
        cart: [
          ...state.cart,
          {
            ...product,
            selected_color: action.color,
            selected_size: action.size,
            qty: productQty,
            sum:
              ((product.price * (product.discount ?? 100)) / 100) *
              productQty,
          },
        ],
      };
    }

    case REMOVE_FROM_CART:
      return {
        cart: state.cart.filter((item) => item.id !== action.product_id),
      };

    case INCREMENT_QUANTITY: {
      const updatedCart = state.cart.map((item) =>
        item.id === action.product_id
          ? { ...item, qty: item.qty + 1 }
          : item
      );
      return { ...state, cart: updatedCart };
    }

    case DECREMENT_QUANTITY: {
      const updatedCart = state.cart.map((item) =>
        item.id === action.product_id
          ? { ...item, qty: minValueOne(item.qty - 1) }
          : item
      );
      return { ...state, cart: updatedCart };
    }

    default:
      return state;
  }
};

export default cartReducer;
